import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor() {}

  logError(message: string, stacktrace: string): void {
    console.log('LoggingService: message:', message, 'stacktrace:', stacktrace);
  }
}
